<template>
  <article class="category">
    <section class="section">
      <div class="container">
        <h1
          v-show="tagTitle"
          class="mb-[24px] font-roboto text-[32px] font-medium leading-[36px]"
        >
          Материалы по тегу &laquo;{{ tagTitle }}&raquo;
        </h1>
        <!-- <div
          v-show="articles?.length"
          class="my-14 flex flex-col justify-between lg:flex-row"
        >
          <CommonTabs
            class="w-fit"
            :list="sortOptions"
            :initial-tab-index="currentTabIndex"
            @on-change="handleSortValue"
          />
        </div> -->
        <div v-if="entities" class="grid-layout gap-8">
          <MainPageCardsReworkedBaseCard
            v-for="entity in entities"
            :key="`article-${entity.id}`"
            class="col-span-full md:col-span-6 lg:col-span-4 xl:col-span-3"
            :data="entity"
            disable-announce
          />
        </div>

        <BaseThePagination :entity="tagEntities" />

        <!-- <div class="mt-[64px] flex justify-center">
          <BaseTheButtonNew
            v-if="tagEntities.hasNextPage.value"
            text="Показать еще"
            @click="tagEntities.fetchNextPage()"
          />
        </div> -->
      </div>
    </section>
    <CommonBlocksPageFooterBlocks class="mt-[64px]" />
  </article>
</template>

<script setup>
const route = useRoute();
const router = useRouter();
const slug = route?.params?.slug;

const selectedSortValue = ref('');
// const sortOptions = [ // SUPPORT-1166
//   { id: 0, name: 'Свежие', model: '', icon: 'timer' },
//   { id: 1, name: 'Популярные', model: 'views', icon: 'eye' },
// ];

const filters = computed(() => {
  return {
    sort_by: selectedSortValue.value,
  };
});

const page = computed(() => Number(route.query?.page) || 1);

const { tagEntities, resetPage } = useTagEntities({ slug, filters, page });
useErrorHandler(() => tagEntities.failureReason.value?.status);

const entities = computed(() => tagEntities?.data?.value?.data ?? []);
const tag = computed(() => tagEntities?.data?.value?.tag ?? null);

watch(filters, (newValue, prevValue) => {
  if (JSON.stringify(newValue) === JSON.stringify(prevValue)) return;
  router.push({ query: { ...route.query, page: undefined } });
  resetPage(prevValue);
});

const tagTitle = computed(() => tag.value?.title);
// const handleSortValue = (e) => (selectedSortValue.value = e);
// const currentTabIndex = computed(
//   () => sortOptions.find((item) => item.model === selectedSortValue.value)?.id,
// );

const { canonicalUrl, title } = useSeoHelper();

useHead(() => ({
  title: title(`${tagTitle.value} | Федеральный портал Истории России`),
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: `Материалы по тегу «${tagTitle.value}». Федеральный портал Истории России.`,
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>

<style lang="scss"></style>
